import {mapGetters} from 'vuex';
export default {
  computed: {
    ...mapGetters({
      participantDisplayNames: 'helper/getParticipantDisplayNames',
      currentOrganization: 'getOrganization',
    }),
    participantNameDict() {
      return this.participantDisplayNames.find(n => n.id === this.currentOrganization.participantDisplayName);
    },
    participantSingularName() {
      return this.participantNameDict.singular;
    },
    participantPluralName() {
      return this.participantNameDict.plural;
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/participantDisplayName.js